import type { IconSvgObject } from './types';

const LocationUser02Icon: IconSvgObject = [
  ["path", { d: "M7 13.9993H9L10.5 18.9993H13.5L15 13.9993H17V11.9993C17 9.23784 14.7614 6.99927 12 6.99927C9.23858 6.99927 7 9.23784 7 11.9993V13.9993Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 18.9962C19 20.6556 15.866 22.0008 12 22.0008C8.13401 22.0008 5 20.6556 5 18.9962", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "12", cy: "4.49927", r: "2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default LocationUser02Icon;
